import React from "react";
import { Box, Switch, Typography } from "@mui/material";
import { MobileCard } from "@ui/components/card";
import { between } from "@ui/components/style/style";
import { useTranslation } from "react-i18next";
export const PermissionCard = ({ module, onPermissionChange, onExtendedSettingsHoverEnter, onExtendedSettingsHoverLeave, }) => {
    const { t } = useTranslation(["common"]);
    const permissions = [
        {
            key: "viewPermission",
            label: t("common:grid.view"),
            checked: module.viewPermission,
            disabled: module.isDashboard || module.isAccessPoints,
            hasPermission: module.hasView,
        },
        {
            key: "editPermission",
            label: t("common:grid.edit"),
            checked: module.editPermission,
            hasPermission: module.hasEdit,
        },
        {
            key: "createPermission",
            label: t("common:grid.create"),
            checked: module.createPermission,
            hasPermission: module.hasCreate,
        },
        {
            key: "deletePermission",
            label: t("common:grid.delete"),
            checked: module.deletePermission,
            hasPermission: module.hasDelete,
        },
    ];
    const visiblePermissions = permissions.filter((p) => p.hasPermission);
    return (React.createElement(MobileCard, null,
        React.createElement(Typography, { variant: "subtitle1", fontWeight: 700 }, module.module),
        visiblePermissions.map((perm) => {
            const moduleId = String(module.id);
            const isExtendedFollowUpEdit = perm.key === "editPermission" &&
                (moduleId === "AccessPoints" || moduleId === "Nodes");
            const switchEl = (React.createElement(Switch, { checked: perm.checked, onChange: (e) => onPermissionChange(moduleId, perm.key, e.target.checked), disabled: perm.disabled, size: "small" }));
            return (React.createElement(Box, { key: perm.key, sx: Object.assign({}, between) },
                React.createElement(Typography, { variant: "body2", color: "text.secondary" }, perm.label),
                isExtendedFollowUpEdit &&
                    onExtendedSettingsHoverEnter &&
                    onExtendedSettingsHoverLeave ? (React.createElement(Box, { onMouseEnter: () => onExtendedSettingsHoverEnter(moduleId, !!module.editPermission), onMouseLeave: onExtendedSettingsHoverLeave, sx: { display: "inline-flex", alignItems: "center" } }, switchEl)) : (switchEl)));
        })));
};
